// WISHLIST SYSTEM - CÓDIGO PARA SHOPIFY
// Configuración
const SHOPIFY_STORE = 'ohmystore-shop.myshopify.com';
const STOREFRONT_TOKEN = 'd90f8c61a95787d7f8a6e82a4c980841';

// Obtener favoritos del cliente
async function getCustomerWishlist() {
  try {
    const customerToken = localStorage.getItem('customerAccessToken');
    
    if (!customerToken) {
      console.log('Cliente no registrado');
      return getLocalWishlist();
    }

    const query = `
      query {
        customer(customerAccessToken: "${customerToken}") {
          id
          metafields(first: 10) {
            edges {
              node {
                namespace
                key
                value
              }
            }
          }
        }
      }
    `;

    const response = await fetch(
      `https://${SHOPIFY_STORE}/api/2024-01/graphql.json`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN,
        },
        body: JSON.stringify({ query }),
      }
    );

    const data = await response.json();
    
    if (data.data?.customer?.metafields) {
      const wishlistField = data.data.customer.metafields.edges.find(
        edge => edge.node.key === 'wish_list'
      );
      return wishlistField ? JSON.parse(wishlistField.node.value) : [];
    }
    
    return getLocalWishlist();
  } catch (error) {
    console.error('Error obteniendo wishlist:', error);
    return getLocalWishlist();
  }
}

// Obtener favoritos del localStorage (fallback)
function getLocalWishlist() {
  return JSON.parse(localStorage.getItem('wishlist')) || [];
}

// Guardar favoritos localmente
function saveLocalWishlist(favorites) {
  localStorage.setItem('wishlist', JSON.stringify(favorites));
}

// Agregar producto a favoritos
async function addToWishlist(productId) {
  const favorites = await getCustomerWishlist();
  
  if (!favorites.includes(productId)) {
    favorites.push(productId);
    saveLocalWishlist(favorites);
    
    // Actualizar visualmente
    updateWishlistUI(favorites);
    
    console.log('Producto agregado a favoritos:', productId);
  }
}

// Remover de favoritos
async function removeFromWishlist(productId) {
  let favorites = await getCustomerWishlist();
  favorites = favorites.filter(id => id !== productId);
  saveLocalWishlist(favorites);
  
  // Actualizar visualmente
  updateWishlistUI(favorites);
  
  console.log('Producto removido de favoritos:', productId);
}

// Verificar si un producto está en favoritos
async function isInWishlist(productId) {
  const favorites = await getCustomerWishlist();
  return favorites.includes(productId);
}

// Actualizar la UI de botones de favoritos
async function updateWishlistUI(favorites) {
  document.querySelectorAll('[data-wishlist-btn]').forEach(btn => {
    const productId = btn.getAttribute('data-product-id');
    if (favorites.includes(productId)) {
      btn.classList.add('in-wishlist');
      btn.innerHTML = '❤️ En favoritos';
    } else {
      btn.classList.remove('in-wishlist');
      btn.innerHTML = '🤍 Agregar a favoritos';
    }
  });
}

// Inicializar botones de favoritos
async function initWishlistButtons() {
  const favorites = await getCustomerWishlist();
  
  document.querySelectorAll('[data-wishlist-btn]').forEach(btn => {
    const productId = btn.getAttribute('data-product-id');
    
    // Establecer estado inicial
    if (favorites.includes(productId)) {
      btn.classList.add('in-wishlist');
      btn.innerHTML = '❤️ En favoritos';
    }
    
    // Agregar evento click
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      
      if (await isInWishlist(productId)) {
        await removeFromWishlist(productId);
      } else {
        await addToWishlist(productId);
      }
    });
  });
}

// Ejecutar cuando la página carga
document.addEventListener('DOMContentLoaded', initWishlistButtons);

// También ejecutar si el DOM ya está listo
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initWishlistButtons);
} else {
  initWishlistButtons();
}